import React from 'react';
import '../constants/AssetsCss';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

class CTransfer extends React.Component {
    constructor(props) {
        super(props);
        this.onTransferToChanged = this.onTransferToChanged.bind(this);
        this.onTransferAmtChanged = this.onTransferAmtChanged.bind(this);
        this.onTransfer = this.onTransfer.bind(this);
        this.handleKeypress = this.handleKeypress.bind(this);

        this.state = {
            username: "",
            availablecompanywallet: "",
            availablePaywallet: "",
            isCompanyWallet: true,
            titleText: "Activation Wallet Transfer",
            trnasferTo: "",
            transferAmt: ""
        }
    }

    componentDidMount() {
        console.log(this.props.history.params.type);
        this.setState({
            isCompanyWallet: this.props.history.params.type !== "cash",
            titleText: this.props.history.params.type !== "cash" ? "Activation Wallet Transfer" : "Payout Wallet Transfer"
        });
        this.getDashboardDetails();
    }
    onTransferToChanged(event) {
        this.setState({ trnasferTo: event.target.value });
    }
    onTransferAmtChanged(event) {
        this.setState({ transferAmt: event.target.value });
    }
    handleKeypress(e) {
        if (e.key === "Enter") {
            this.onTransfer();
        }
    };
    async onTransfer() {
        if (!this.validate()) {
            return;
        }
        let jsondata = '{ "transferamt" : "' + this.state.transferAmt + '","transferto" : "' + this.state.trnasferTo + '"}';
        let url = this.props.history.params.type !== "cash" ? "CompanyWalletTransferConfirm.asp" : "CashWalletTransferConfirm.asp";
        let res = await GetORPostAsync(url, "POST", jsondata, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            if (res.message === "Session Expired") {
                this.props.history.push({
                    pathname: "/"
                });
            }
            return;
        }
        let thisvar = this;
        swal("Please enter the transaction password", {
            content: "input",
            dangerMode: true,
            buttons: true,
        }).then((value) => {
            if (value) {
                let jsonstr = {
                    transferamt: thisvar.state.transferAmt,
                    transferto: thisvar.state.trnasferTo,
                    TransactionFee: res.TransactionFee,
                    OTP: value,
                    tpassword: value
                };
                this.onTransferConfirm(JSON.stringify(jsonstr));
            }
        });
    }
    async onTransferConfirm(jsondata) {
        if (!this.validate()) {
            return;
        }
        let url = this.props.history.params.type !== "cash" ? "CompanyWalletTransfer.asp" : "CashWalletTransfer.asp";
        let res = await GetORPostAsync(url, "POST", jsondata, localStorage.getItem("token"));
        if (res.status === "error") {
            toast(res.message);
            return;
        }
        toast(res.message);
        this.setState({
            transferAmt: "",
            trnasferTo: ""
        });
        this.getDashboardDetails();
    }
    validate() {
        let isValid = false;
        if (!this.state.trnasferTo) {
            toast("Enter valid transfer to");
        }
        else if (!this.state.transferAmt) {
            toast("Enter the amount");
        }
        else {
            isValid = true;
        }
        return isValid;
    }
    async getDashboardDetails() {
        let res = await GetORPostAsync("GetDashboardDetails.asp", "GET", null, localStorage.getItem("token"));
        if (res.status === "error" && res.message === "Session Expired") {
            toast(res.message);
            this.props.history.push({
                pathname: "/"
            });
            return;
        }
        this.setState(res);
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>{this.state.titleText}</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>{this.state.titleText}</h3>
                        </div>
                        <div class="col-lg-8 mt-3">
                            <div class="card radius-10 border border-1 shadow-none">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div>
                                            <p class="mb-0 text-white">Wallet Balance</p>
                                            <h4 class="my-1">{this.state.isCompanyWallet ? this.state.availablecompanywallet : this.state.availablePaywallet}</h4>
                                        </div>
                                        <div class="widgets-icons-2 bg-gradient-moonlit text-white ml-auto">
                                            <svg className="side-menu__icon" style={{ fill: 'white' }} xmlns="http://www.w3.org/2000/svg" height="16" viewBox="0 0 16 16" width="16"><path d="M0 0h16v16H0V0z" fill="none" /><path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1H1zm7 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
                                                <path d="M0 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V5zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V7a2 2 0 0 1-2-2H3z" /></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3"><label for="amounttowithdraw" class="form-label">Transfer To</label><input type="text" class="form-control" placeholder="Transfer to" onChange={this.onTransferToChanged} value={this.state.trnasferTo} /></div>
                            <div class="mb-3"><label for="walletaddress" class="form-label">Transfer Amount</label><input type="text" class="form-control" placeholder="Transfer amount" onChange={this.onTransferAmtChanged} value={this.state.transferAmt} /></div>
                            <div class="mb-3 mt-5">
                                <div class="d-grid"><button onClick={this.onTransfer} type="submit" class="btn btn-primary w-100">Transfer</button></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default withRouter(CTransfer);